<template>
  <el-dialog
    custom-class="evaluation_dialog"
    title="科技成果标准化评价 -- 审核"
    :visible.sync="auditMaterialDialog"
    :show-close="false"
    :modal-append-to-body="false"
    width="800px"
    center
    :close-on-click-modal="false"
  >
    <div slot="title" class="header-title">
      <div>科技成果标准化评价 -- 审核</div>
      <div @click="close(false)"><i class="el-icon-circle-close"></i></div>
    </div>
    <div class="apply-form" data-aos="fade-up" data-aos-once="true">
      <div @click="showOne">
        <p>基本信息<i class="el-icon-arrow-down" v-if="show1"></i><i class="el-icon-arrow-right" v-else></i></p>
      </div>
      <el-form
        ref="form"
        :model="form"
        style="margin-top: 20px"
      >
        <div v-if="show1">
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="成果名称：" prop="achievementName">
                <el-input v-model="form.achievementName" placeholder="请输入成果名称" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成果类别：" prop="achievementType">
                <el-select v-model="form.achievementType" placeholder="请选择成果类别" style="width: 100%;" disabled>
                  <el-option label="应用类" :value="1"></el-option>
                  <el-option label="基础类" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="联系姓名：" prop="contactName">
                <el-input v-model="form.contactName" placeholder="请填写联系姓名" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式：" prop="contactInformation">
                <!-- <el-select v-model="form.contactInformation" placeholder="请选择联系方式" style="width: 50%;">
                  <el-option :value="2" label="手机号"></el-option>
                  <el-option :value="1" label="电话"></el-option>
                </el-select> -->
                
                <el-input v-model="form.contactInformation" placeholder="请输入手机号/电话" disabled></el-input>
              </el-form-item>
              <!-- <el-form-item prop="phone" class="phone_value">
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="成果体现形式：" prop="achievements">
                <el-input v-model="form.achievements" placeholder="请输入成果体现形式" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成果标准：" prop="achievementCriteria">
                <el-input v-model="form.achievementCriteria" placeholder="请输入成果标准" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="评价目的：" prop="evaluationPurpose">
                <el-input v-model="form.evaluationPurpose" placeholder="请输入评价目的" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课题来源：" prop="subjectSource">
                <el-input v-model="form.subjectSource" placeholder="请输入课题来源" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="课题立项名称：" prop="projectName">
                <el-input v-model="form.projectName" placeholder="请输入课题立项名称" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课题立项编号：" prop="projectApprovalNumber">
                <el-input v-model="form.projectApprovalNumber" placeholder="请输入课题立项编号" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="开始日期：" prop="startDate">
                <el-date-picker v-model="form.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" disabled> </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完成日期：" prop="completionDate">
                <el-date-picker v-model="form.completionDate" type="date" placeholder="选择完成日期" style="width: 100%;" disabled> </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="战略性新兴产业：" prop="emergingIndustries">
                <el-input v-model="form.emergingIndustries" placeholder="请输入战略性新兴产业" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属高新技术领域：" prop="highTechField">
                <el-select v-model="form.highTechField" placeholder="请选择所属高新技术领域" style="width: 100%;" disabled>
                  <el-option label="电子信息" :value="1"></el-option>
                  <el-option label="生物与新医药" :value="2"></el-option>
                  <el-option label="航空航天" :value="3"></el-option>
                  <el-option label="新材料" :value="4"></el-option>
                  <el-option label="高技术服务" :value="5"></el-option>
                  <el-option label="新能源及节能技术" :value="6"></el-option>
                  <el-option label="资源与环境技术" :value="7"></el-option>
                  <el-option label="高技术改造传统产业" :value="8"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="成果主要应用行业：" prop="applicationAchievements">
                <el-input v-model="form.applicationAchievements" placeholder="请输入成果主要应用行业" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="知识产权形式：" prop="intellectualProperty">
                <el-input v-model="form.intellectualProperty" placeholder="请输入知识产权形式" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="合作转化方式：" prop="cooperativeTransformation">
                <el-select v-model="form.cooperativeTransformation" placeholder="请选择合作转化方式" style="width: 100%;" disabled>
                  <el-option :label="item.name" :value="item.id" v-for="item in cooperates" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="160">
          <el-col :span="24">
            <div style="float: left;" class="apply-form benefit" @click="showTwo">
              <p>转化效益<i class="el-icon-arrow-down" v-if="show2"></i><i class="el-icon-arrow-right" v-else></i></p>
            </div>
          </el-col>
        </el-row>
        <div v-if="show2">
          <el-row :gutter="160">
            <el-col :span="12">
              <el-form-item label="已收益：" prop="earned">
                <el-input v-model="form.earned" placeholder="请输入金额" disabled><template slot="append">元</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预计收益：" prop="estimatedIncome">
                <el-input v-model="form.estimatedIncome" placeholder="请输入金额" disabled><template slot="append">元</template></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="成果简介：" prop="achievementProfiles" class="achievement">
                <editor
                  v-model="form.achievementProfiles"
                  :upload-url="uploadURL"
                  :img-show-url="imgUrl"
                  :disabled="true"
                ></editor>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        
        <el-row :gutter="160" v-if="form.respVO">
          <el-col :span="24">
            <div style="float: left;" class="apply-form benefit" @click="showThree">
              <p>原始材料<i class="el-icon-arrow-down" v-if="show3"></i><i class="el-icon-arrow-right" v-else></i></p>
            </div>
          </el-col>
        </el-row>
        <div v-if="show3 && form.respVO">          
          <el-row :gutter="160">
            <el-col :span="24">
              <el-form-item label="项目名称：" prop="projectName">
                <el-input v-model="form.respVO.projectName" placeholder="请输入项目名称" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="立项日期：" prop="projectApprovalDate">
                <el-date-picker v-model="form.respVO.projectApprovalDate" type="date" placeholder="选择立项日期" style="width: 100%;" disabled> </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结题日期：" prop="closingDate">
                <el-date-picker v-model="form.respVO.closingDate" type="date" placeholder="选择结题日期" style="width: 100%;" disabled> </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目说明：" prop="projectDescription">
                <el-input v-model="form.respVO.projectDescription" type="textarea" placeholder="请输入项目说明" style="width: 100%;" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术交付物类别：" prop="technologyPayType">
                <el-input v-model="form.respVO.technologyPayType" placeholder="请输入技术交付物类别" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="研究形式：" prop="researchForm">
                <el-input v-model="form.respVO.researchForm" placeholder="请输入研究形式" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术领域：" prop="technicalField">
                <el-input v-model="form.respVO.technicalField" placeholder="请输入技术领域" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用领域：" prop="applicationArea">
                <el-input v-model="form.respVO.applicationArea" placeholder="请输入应用领域" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业绩：" prop="achievement">
                <el-input v-model="form.respVO.achievement" placeholder="请输入业绩" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="国内外研究状况分析：" prop="researchStatus">
                <el-input v-model="form.respVO.researchStatus" placeholder="请输入国内外研究状况分析" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="研究目的、意义、研究内容及已有基础：" prop="researchContents">
                <el-input v-model="form.respVO.researchContents" placeholder="请输入研究目的、意义、研究内容及已有基础" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="研究结果：" prop="researchResults">
                <el-input v-model="form.respVO.researchResults" placeholder="请输入研究结果" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术创新程度：" prop="technologicalInnovation">
                <el-input v-model="form.respVO.technologicalInnovation" placeholder="请输入技术创新程度" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术指标的先进程度：" prop="technicalIndicators">
                <el-input v-model="form.respVO.technicalIndicators" placeholder="请输入技术指标的先进程度" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术成熟度：" prop="technologyMaturity">
                <el-input v-model="form.respVO.technologyMaturity" placeholder="请输入技术成熟度" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经济及社会效益：" prop="socialBenefits">
                <el-input v-model="form.respVO.socialBenefits" placeholder="请输入经济及社会效益" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主要研发人员简介：" prop="personnelProfile">
                <el-input v-model="form.respVO.personnelProfile" placeholder="请输入主要研发人员简介" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="160">
            <el-col :span="24">
              <el-form-item label="附件材料：" prop="accessoryMaterialsSrc">              
                <el-upload
                  class="upload-demo"
                  :action="this.uploadURL"
                  style="text-align: left"
                  :file-list="accessoryMaterialsSrc"
                  list-type="picture"
                  :disabled="true"
                >
                <div slot="file" slot-scope="{file}" class="file-list">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  >
                  <div class="file-name">{{ file.name }}</div>
                  <div class="file-download" @click="handleDownload(file)">下载</div>
                </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item style="margin: 20px 0">
          <el-button round type="primary" plain @click="onAudit(5)">通 过</el-button>
          <el-button round type="danger" plain @click="onAudit(6)">退 回</el-button>
          <el-button round type="info" plain @click="close(false)">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>


  </el-dialog>
</template>

<script>
import editor from "../../../components/tinymce-editor/tinymce-editor";
import { DownLoadUrl } from '../../../utils/tool';
export default {
  components: {
    editor
  },
  props: {
    auditMaterialDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    auditMaterialDialog: {
      handler(newVal, oldVle) {
        if (newVal) {
          console.log(this.id)
          this.getDetail()
          // console.log('this.checkForm:', this.checkForm)
          // this.form = this.checkForm
        }
      }
    }
  },
  data() {
    return{
      accessoryMaterialsSrc: [],
      show1: true,
      show2: true,     
      show3: true, 
      fileList: [],
      form: {
        achievementName: "", // 成果名称
        achievementType: "", // 成果类型:1应用类，2基础类
        contactName: "", // 联系姓名
        contactInformation: "", // 联系方式
        achievements: "", // 成果体现形式
        achievementCriteria: "", // 成果标准
        evaluationPurpose: "", // 评价目的
        subjectSource: "", // 课题来源
        projectName: "", // 课题立项名称
        projectApprovalNumber: "", // 课题立项编号
        startDate: "", // 开始时间
        completionDate: "", // 完成日期
        emergingIndustries: "", // 战略性新兴产业
        highTechField: "", // 所属高新技术领域
        applicationAchievements: "", // 成果主要应用行业
        cooperativeTransformation: "", // 合作转化方式
        intellectualProperty: "", // 知识产权形式
        earned: "", // 已收益
        estimatedIncome: "", // 预计收益
        achievementProfiles: "", // 成果简介
      },   
      cooperates: [
        {
          id: "001",
          name: "委托开发",
          num: 0,
        },
        {
          id: "002",
          name: "许可转让",
          num: 0,
        },
        {
          id: "003",
          name: "完全转让",
          num: 0,
        },
        {
          id: "008",
          name: "非专利转让",
          num: 0,
        },
        {
          id: "009",
          name: "专利权转让",
          num: 0,
        },
        {
          id: "010",
          name: "专利申请权转让",
          num: 0,
        },
        {
          id: "011",
          name: "专利实施许可转让",
          num: 0,
        },
        {
          id: "004",
          name: "技术入股",
          num: 0,
        },
        {
          id: "005",
          name: "技术许可",
          num: 0,
        },
        {
          id: "006",
          name: "合作转化",
          num: 0,
        },
        {
          id: "007",
          name: "其他",
          num: 0,
        },
      ],      
      activities: [
        {
          content: "受理",
          timestamp: "",
          size: "large",
          download: [],
        },
        {
          content: "签订委托合同",
          timestamp: "",
          size: "large",
          download: [],
        },
        {
          content: "提交原始材料",
          timestamp: "",
          size: "large",
          download: [],
        },
        {
          content: "审核",
          timestamp: "",
          size: "large",
          download: [],
        },
        {
          content: "出具评价报告",
          timestamp: "",
          size: "large",
          download: [],
        },
      ],
    }
  },
  methods: {
    handleDownload(file) {
      console.log('handleDownload', file)
      if (file.url) {
        const url = file.url;
        DownLoadUrl(url);
      }
    },
    getDetail() {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/voucher/achievement-appraise/get?id=${this.id}`).then(res => {
        if (res.code == 0) {
          console.log(res.data)
          this.form = res.data
          this.accessoryMaterialsSrc = res.data.respVO.accessoryMaterialsSrc ? JSON.parse(res.data.respVO.accessoryMaterialsSrc) : []
        }
      });
    },
    // 通过审核
    onAudit(type) {
      this.$emit('opinionShow', type, this.form.respVO.id)
    },
    showOne() {
      this.show1 = !this.show1
    },
    showTwo() {
      this.show2 = !this.show2
    },
    showThree() {
      this.show3 = !this.show3
    },
    onSubmit() {

    },
    close(flag) {
      this.$emit('auditClose', flag)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.evaluation_dialog {
    border-radius: 6px;
    .el-dialog__header{
      border-radius: 6px 6px 0 0;
      background: #fff !important;
      padding: 1px 0 0 0;
      .header-title{
        display: flex;
        width: 100%;
        position: relative;
        height: 100%;
        line-height: 50px;
        text-align: left;
        padding: 0 0 0 26px;
        font-weight: 600;
        font-size: 16px;
        justify-content: space-between;

        &::before{
          content: "";
          position: absolute;
          width: 10px;
          height: 20px;
          background-color: #428DFF;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
        i{
          cursor: pointer;
          margin-right: 10px;
        }
      }
      
    }

    .el-dialog__body{
      .benefit{
        padding-bottom: 20px;
      }
      .apply-form {
        width: 100%;
        display: flex;
        flex-direction: column;
        font-size: 20px;
        .is-disabled{
          .el-input__inner{
            color: #333333 !important;
          }
        }
        p {
          text-align: left;
          position: relative;
          padding: 10px 0 10px 26px;
          background-color: #F2F2F2;

          &::before {
            width: 10px;
            height: 20px;
            background: #428DFF;
            display: block;
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0,-50%);
          }
          i{
            position: absolute;
            right: 6px;
            top: 50%;
            transform: translate(0,-50%);
            color: #428DFF;
          }
        }
        .el-upload-list{
          .el-upload-list__item{
            position: relative;
            .file-list{
              display: flex;
              align-items: center;
              img{
                margin-right: 20px;
              }
              .file-download{
                position: absolute;
                top: 50%;
                right: 20px;
                transform: translate(0, -50%);
                cursor: pointer;
                border: 1px solid #333;
                padding: 2px 4px 1px 4px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:hover{
                  color: #428DFF;
                  border: 1px solid #428DFF;
                }
              }
            }
          }
        }
      }
    }
    .el-form-item__content{
      text-align: center;
    //   .el-button--primary{
    //     width: 180px;
    //     height: 40px;
    //     background: #428DFF;
    //     border-radius: 8px;
    //     font-size: 16px;
    //   }
    //   .el-button--info{
    //     width: 180px;
    //     height: 40px;
    //     background: #F2F2F2;
    //     border-radius: 8px;
    //     font-size: 16px;
    //     color: #333333;
    //     margin-left: 20px;
    //     border: none;
    //   }
    }
  }
</style>